import { useTranslation } from 'react-i18next';
import { Button, Column, List, Label, Icon } from 'components';
import { tCurrentConsumable } from 'types/services/devices';
import { tError } from 'types/global';
import { colorBlueBasic, colorRedBasic } from 'styles/GlobalStyles';
import { AddButtonWrapper, ListWrapper } from '../AddEditFormDevices.style';

type tConsumables = {
  disabled?: boolean;
  preview?: boolean;
  openForm: (id: number | null) => void;
  data: tCurrentConsumable[];
  onChange: (data: any) => void;
  errors: tError[];
};

const Consumables: React.FC<tConsumables> = ({
  disabled = false,
  preview = false,
  openForm = () => {},
  data: consumables,
  onChange,
  errors = [],
}): JSX.Element => {
  const { t } = useTranslation();

  const deleteItem = (id: number) => {
    onChange({ fieldName: 'consumables', label: consumables.filter((item) => item.id !== id) });
  };

  const errorNum = errors.map((err) => (err?.loc ? err?.loc[0] : null));
  const items =
    consumables?.map((consumable, index) => {
      return {
        ...consumable,
        error: errorNum.includes(index),
        actions:
          disabled || preview
            ? [
                {
                  action: (
                    <Icon width='1rem' height='1rem' icon='visibility' fill={colorBlueBasic} />
                  ),
                  actionHandler: () => openForm(consumable.id),
                },
              ]
            : [
                {
                  action: <Icon width='1rem' height='1rem' icon='edit' fill={colorBlueBasic} />,
                  actionHandler: () => openForm(consumable.id),
                },
                {
                  action: <Icon width='1rem' height='1rem' icon='close' fill={colorRedBasic} />,
                  actionHandler: () => deleteItem(consumable.id),
                },
              ],
      };
    }) ?? [];

  return (
    <>
      <Column>
        <ListWrapper>
          <Label
            styles={{
              alignItems: 'flex-start',
              marginTop: consumables.length > 0 ? '5px' : 0,
              maxWidth: '90px',
            }}
          >
            {t('Consumables')}
          </Label>
          <List items={items} noItemsCopy={t('No assigned consumables')} />
        </ListWrapper>
      </Column>
      {!disabled && !preview && (
        <AddButtonWrapper>
          <Button
            icon='addCircle'
            onClick={() => openForm(null)}
            variant='blue'
            disabled={disabled}
          >
            {t('Add')}
          </Button>
        </AddButtonWrapper>
      )}
    </>
  );
};

export default Consumables;
